const B_1 = [
    {
        title: '审核报名资料',
        path: '/bidding/projectflow/toubiao/auditbmzl/list'
    }
]
export default {
    path: 'auditbmzl',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-toubiao-auditbmzl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/tou/audit-bmzl/list'),
            meta: {
                title: '审核报名资料列表',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/tou/audit-bmzl/detail'),
            meta: {
                title: '审核报名资料详情',
                bread: '/bidding/projectflow/toubiao/auditbmzl/detail'
            },
        }       
    ]
}